import { resolvePageComponent } from './resolve';

/* eslint-disable */
export default (regionTID) => {

  const createSimpleRoute = (urlPath, component, name = null) => {
    const route = {
      path: urlPath,
      component: component,
      alias: [`/award${urlPath}`]
    };

    if (name) {
      route.name = name;
    }

    return route;
  }

  const createPageComponent = (pageTID) => {
    return resolvePageComponent(regionTID, pageTID)
  }

  const Confirm = (resolve) => {
    require.ensure(['./appLegacy/pages/confirm/Confirm.vue'], () => {
      resolve(require('./appLegacy/pages/confirm/Confirm.vue'));
    });
  };

  return [
    createSimpleRoute('/', createPageComponent('home/Home')),
    createSimpleRoute('/about/', createPageComponent('about/About')),
    createSimpleRoute('/members/', createPageComponent('members/Members')),
    createSimpleRoute('/news/', createPageComponent('news/News')),
    createSimpleRoute('/votes/', createPageComponent('votes/Votes')),
    createSimpleRoute('/votes/:year(\\d{4})/', createPageComponent('archive/Archive'), 'archive-votes'),
    createSimpleRoute('/votes/:rubric/', createPageComponent('votesForm/VotesForm')),
    createSimpleRoute('/partners/', createPageComponent('partners/Partners')),
    createSimpleRoute('/live/', createPageComponent('live/Live')),
    createSimpleRoute('/docs/', createPageComponent('docs/Docs')),
    createSimpleRoute('/votes/:rubric/:year(\\d{4})/', createPageComponent('archiveWinners/ArchiveWinners'), 'archive-rubric-votes'),
    createSimpleRoute('/kontur/', createPageComponent('kontur/Kontur')),
    createSimpleRoute('/404/', createPageComponent('notFound/NotFound')),
    createSimpleRoute('/confirm/', Confirm, 'activate'),
    createSimpleRoute('/unsubscribe/', Confirm, 'deactivate'),
    { path: '*', redirect: '/404/' },
  ]
}



// WEBPACK FOOTER //
// ./src/routes.js